import { render, staticRenderFns } from "./IntegrationOrders.vue?vue&type=template&id=a3f186a0&scoped=true"
import script from "./IntegrationOrders.vue?vue&type=script&lang=js"
export * from "./IntegrationOrders.vue?vue&type=script&lang=js"
import style0 from "./IntegrationOrders.vue?vue&type=style&index=0&id=a3f186a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f186a0",
  null
  
)

export default component.exports